import { isEmpty, pick } from 'lodash';
import { useState } from 'react';

//components
import Dropdown from '../../../Dropdown';
import Slider from '../../../Slider';
import { useIdCatalogSearch } from '../../context';

//styles
import { ControlWrapper, LabelActionButton, LabelActionButtonContainer } from '../../styles';
import { Container, SlidersList } from './styles';

const EquipmentAdvancedFilter = () => {
  const {
    dropdownsOptions,
    searchFilter,
    updateSearchFilterField,
    removeFilterOption,
    updateFilterOptionValue,
    removeAllFilterOptions,
  } = useIdCatalogSearch();
  const { filterOptions } = searchFilter;
  const [areFilterOptionsCollapsed, setAreFilterOptionsCollapsed] = useState(false);
  const { projects, equipmentList } = dropdownsOptions;

  const toggleCollapsedOptions = () => setAreFilterOptionsCollapsed((current) => !current);

  return (
    <Container>
      <ControlWrapper>
        <Dropdown
          isLoading={projects.isLoading}
          options={projects.options}
          isOptional={false}
          value={searchFilter.projectId}
          placeholder='Select project'
          onChange={({ value }) => updateSearchFilterField('projectId', value)}
          isDisabled={false}
        />
      </ControlWrapper>
      <ControlWrapper>
        <Dropdown
          isLoading={equipmentList.isLoading}
          options={equipmentList.options}
          isOptional={false}
          value={searchFilter.equipmentType}
          placeholder='Select Equipment tag'
          onChange={({ value }) => updateSearchFilterField('equipmentType', value)}
          isDisabled={false}
        />
      </ControlWrapper>

      {!isEmpty(filterOptions) && (
        <LabelActionButtonContainer>
          <LabelActionButton onClick={() => removeAllFilterOptions()}>Remove all filters</LabelActionButton>
        </LabelActionButtonContainer>
      )}

      {!isEmpty(filterOptions) && (
        <LabelActionButtonContainer>
          <LabelActionButton
            onClick={() => toggleCollapsedOptions()}
            color={'#4175c2'}
            style={{ fontWeight: 'bold' }}>
            {areFilterOptionsCollapsed ? 'Show filters' : 'Hide filters'} (
            <label className='counter'>{filterOptions.length}</label>)
          </LabelActionButton>
        </LabelActionButtonContainer>
      )}

      {!areFilterOptionsCollapsed && (
        <SlidersList>
          {filterOptions.map((option) => (
            <ControlWrapper key={option.id}>
              <Slider
                range={pick(option, ['min', 'max'])}
                defaultValue={option.value}
                infoLabel={option.name}
                unit={option.unit}
                onChange={(value) => updateFilterOptionValue(option.id, value)}
                onClose={() => removeFilterOption(option.id)}
              />
            </ControlWrapper>
          ))}
        </SlidersList>
      )}
    </Container>
  );
};

export default EquipmentAdvancedFilter;
